import React from 'react';
import { motion } from 'framer-motion';
import { pets } from '../data/mockData';

export default function PetSelector({ activePetId, setActivePetId }) {
  return (
    <div className="flex gap-4 overflow-x-auto pb-4 pt-2 px-1 hide-scrollbar">
      {pets.map((pet) => {
        const isActive = activePetId === pet.id;
        return (
          <motion.button
            key={pet.id}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setActivePetId(pet.id)}
            className={`relative flex flex-col items-center gap-2 min-w-[80px] p-2 rounded-2xl transition-all ${
              isActive ? 'bg-white shadow-[0_8px_32px_rgba(0,71,171,0.12)]' : 'hover:bg-white/50'
            }`}
          >
            <div className={`relative w-16 h-16 rounded-full p-1 transition-colors duration-300 ${
              isActive ? 'bg-gradient-to-tr from-[#0047AB] to-[#FF7F50]' : 'bg-slate-200'
            }`}>
              <img
                src={pet.image}
                alt={pet.name}
                className="w-full h-full rounded-full object-cover border-2 border-white"
              />
              {isActive && (
                <motion.div
                  layoutId="activePetRing"
                  className="absolute inset-0 rounded-full border-2 border-[#FF7F50] -m-1"
                  initial={false}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}
            </div>
            <span className={`text-sm font-semibold ${isActive ? 'text-[#0047AB]' : 'text-slate-500'}`}>
              {pet.name}
            </span>
          </motion.button>
        );
      })}
    </div>
  );
}